// eslint-disable-next-line no-unused-vars
import { action, observable } from "mobx";
import { createContext } from "react";
import { message } from "antd";

import { fetchListApi, fetchArticleApi, updateLike } from "../api/api";
import {
  DetailData,
  formatList,
  formatDetail,
} from "../utils/formatArticleData";

// import { Notify } from "../components";

class articleStore {
  @observable public list = [];
  @observable public loading = false;
  @observable public keyword = "";
  @observable public pagination = {
    total: 0,
    current: 1,
    pageSize: 20,
    hasNextPage: false,
  };
  @observable public params = {
    page: 1,
    per: 20,
  };
  // 打开哪个筛选列表
  @observable public openName = "";
  //详情页默认收起列表
  @observable public showList = false;
  // 是否显示清空按钮
  @observable public showClear = false;
  @observable public publishOption = [
    { label: 0, value: "未选择" },
    { label: 7, value: "1周内" },
    { label: 30, value: "1月内" },
    { label: 90, value: "3月内" },
    { label: 180, value: "6月内" },
    { label: 366, value: "1年内" },
  ];
  @observable public sortOption = [
    { label: "relevance", value: "相关度" },
    { label: "time", value: "时间" },
    { label: "overall", value: "综合" },
  ];
  @observable public tags = [];
  @observable public elapsedDays = 0;
  @observable public articlesCount = 0;
  @observable public choosePublish = 0;
  @observable public chooseSort = "overall";
  @observable public chooseTags = [];

  @observable public detail: DetailData = {
    author: {},
    seo: {},
  };
  // 详情推荐文章列表
  // @observable public similarList = [];
  @observable public detailLoading = false;

  @action
  setKeyword = (keyword: string) => {
    this.clearChoose();
    this.keyword = keyword;
  };

  @action
  setShowList = (value: boolean) => {
    this.showList = value;
  };

  @action
  revert = () => {
    this.list = [];
    this.params = {
      page: 1,
      per: 20,
    };
    this.pagination = {
      total: 0,
      current: 1,
      pageSize: 20,
      hasNextPage: false,
    };
  };

  @action
  nextPage = async (keyword?: string) => {
    this.params.page += 1;
    await this.fetchList(keyword);
  };

  @action
  fetchList = async (keyword?: string) => {
    this.loading = true;
    // !next && this.revert();
    if (
      !(this.params.page > 1 && this.pagination.current === this.params.page)
    ) {
      const params = {
        ...this.params,
        keyword,
        published: this.choosePublish,
        sort: this.chooseSort,
        tags: this.chooseTags.map((item: string) => item).join("&tags[]="),
      };
      const res = await fetchListApi(keyword ? params : this.params);
      if (!keyword && !this.showClear) {
        this.tags = res.tags;
      }
      this.elapsedDays = res.elapsedDays;
      this.articlesCount = res.publishedArticlesCount;
      // this.list、this.pagination赋值顺序不能变，
      // 因为this.pagination.current如果先赋值会改变判断条件的结果
      this.list =
        this.params.page > 1 && this.pagination.current !== this.params.page
          ? [...this.list, ...formatList(res.articles)]
          : formatList(res.articles);
      this.pagination = {
        total: res.totalCount,
        current: res.currentPage || 20,
        pageSize: this.params.per,
        hasNextPage: res.hasNextPage,
      };
    }
    this.loading = false;
  };

  @action
  setOpenName = (name: string) => {
    this.openName = this.openName === name ? "" : name;
  };

  // 修改筛选项
  @action
  chooseOption = (name: string, label: string | number) => {
    if (name === "publishOption") {
      this.choosePublish = label as number;
    } else {
      this.chooseSort = label as string;
    }
    this.setShowClear();
  };

  // 修改选中tags
  @action
  chooseTag = (label: string) => {
    const hasLabel = this.chooseTags.includes(label);
    if (hasLabel) {
      this.chooseTags = this.chooseTags.filter(tag => tag !== label);
    } else {
      this.chooseTags.push(label);
    }
    this.setShowClear();
  };

  @action
  clearChoose = () => {
    this.openName = "";
    // 默认选项
    this.choosePublish = 0;
    this.chooseSort = "overall";
    this.chooseTags = [];
    this.setShowClear();
    this.revert();
  };

  // 检查并判断，是否显示清空按钮
  @action
  setShowClear = () => {
    this.showClear =
      this.choosePublish !== 0 ||
      this.chooseSort !== "overall" ||
      (this.chooseTags && this.chooseTags.length > 0);
  };

  @action
  fetchDetail = async (id: string) => {
    this.detailLoading = true;
    const result = await fetchArticleApi(id);
    this.detail = formatDetail(result);
    // this.similarList = formatList(result.related_articles);
    this.detailLoading = false;
  };

  @action
  onUpdateLike = (id: string, liked: boolean): Promise<void> => {
    return new Promise(async (resolve, reject) => {
      await updateLike(id, liked)
        .then(response => {
          this.detail.liked = response.liked;
          this.detail.likes_count = response.likes_count;
          resolve();
        })
        .catch(error => {
          message.error(error);
        });
    });
  };

  // 推荐文章点赞
  // @action
  // onUpdateSimilar = async (id: string, liked: boolean) => {
  //   await updateLike(id, liked, response => {
  //     if (response.statusCode === 200) {
  //       console.log("response", response.body);
  //       this.similarList.map((item) => {
  //         if (id === item.id) {
  //           console.log("id", id);
  //           item.liked = response.body.liked;
  //           item.likes_count = response.body.likes_count;
  //         }
  //       });
  //     } else {
  //       message.error(response.message);
  //     }
  //   });
  // };
}
export default createContext(new articleStore());
